module.exports = __webpack_public_path__ + "media/images/internationalSafetyLogo-c5b82f66.jpeg";